const apps = [
    'grabcadApp',
    'groupsApp',
    'groupEditApp',
    'engineersEdit',
    'engineersApp',
    'tutorialsApp',
    'inboxApp',
    'competitionsApp',
    'communityReportApp',
    'questionApp',
    'questionEditApp',
    'opentoworkApp',
    'communityadsApp',
    'shopApp',
    'styleguideApp',
    'dashboardApp',
    'tutorialEditorApp'
];

export default () => apps.filter(item => document.querySelector(`#${item}`));
